export default __webpack_public_path__ + "static/media/358.21fb8965.jpg";